import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import React from 'react';
import Icon from '@ui/Icon';

export interface CheckboxInputProps extends CheckboxProps {
  id: string;
  label?: string;
  'aria-label'?: string;
}

/**
 * @description Checkbox input used for boolean/toggle-style inputs
 *
 * @example
 * <CheckboxInput checked={checked} />
 * <CheckboxInput indeterminate checked={checked} />
 */
const CheckboxInput = (props: CheckboxInputProps) => {
  const {
    checked,
    indeterminate,
    icon,
    checkedIcon,
    indeterminateIcon,
    'aria-label': ariaLabel,
    inputProps,
    ...rest
  } = props;
  return (
    <Checkbox
      {...rest}
      checked={checked}
      indeterminate={indeterminate}
      icon={icon ?? <Icon type="checkbox" />}
      checkedIcon={checkedIcon ?? <Icon type="checkboxChecked" />}
      indeterminateIcon={
        indeterminateIcon ?? <Icon type="checkboxIndeterminate" />
      }
      inputProps={{
        ...inputProps,
        'aria-label': ariaLabel || inputProps?.['aria-label'],
      }}
    />
  );
};

export default CheckboxInput;
